import state from './state';
import { IMutations } from '@/models/store/mutations.interface';

const updateRoute = (): void => {
	// Maintain a url format which uses a hash to separate the universityAdmin url part from the microservice url part.
	let url = `${window.location.origin}/analytics-dashboard/#/${state.router.current}`;
	if (state.router.props.id) {
		url += `/${state.router.props.id}/`;
	}

	// Keep the url in the address bar up-to-date.
	history.pushState({}, '', url);
};

const mutations: IMutations = {
	setAvailableDashboards: (dashboards) => {
		state.availableDashboards = dashboards;
	},
	setCurrentRoute: (name, id) => {
		state.router.props.id = id ? id : '';
		state.router.current = name;
		updateRoute();
		state.tracker.trackPageView();
	},
	setLoadingStateDashboards: (loadingState) => {
		state.loadingStateDashboards = loadingState;
	},
	setModalDashboardPreviewState: (dashboardState) => {
		state.modalDashboardPreviewState = dashboardState;
	},
	setModalErrorState: (errorState) => {
		state.modalErrorState = errorState;
	},
	setRoutePropId: (id) => {
		state.router.props.id = id;
		updateRoute();
	},
	setStandAloneLogin: (standAloneLogin) => {
		state.standAloneLogin = standAloneLogin;
	},
	setTableauJWT: (jwt) => {
		state.tableauJWT = jwt;
	}
};

export default mutations;
